export const StepsSubStepsForHire = [
  "Pre-Hire:PeopleSoft: Manage Hire",
  "Pre-Hire:Initiate Onboarding",
  "Pre-Hire:Error: Initiate Onboarding",
  "Pre-Hire:No Show - Rehire",
  "Hire Confirmed:Hired Direct",
  "Hire Confirmed:Hired - Admin Term",
  "Hire Confirmed:Hired Contingent",
];
